import { render, staticRenderFns } from "./TabPage.vue?vue&type=template&id=60abe490&scoped=true&"
import script from "./TabPage.vue?vue&type=script&lang=js&"
export * from "./TabPage.vue?vue&type=script&lang=js&"
import style0 from "./TabPage.vue?vue&type=style&index=0&id=60abe490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abe490",
  null
  
)

export default component.exports